import { render } from "./tripDetail.vue?vue&type=template&id=69acd088&scoped=true"
import script from "./tripDetail.vue?vue&type=script&lang=js"
export * from "./tripDetail.vue?vue&type=script&lang=js"

import "./tripDetail.vue?vue&type=style&index=0&id=69acd088&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-69acd088"

export default script